import {
  CHECK_CAMPAIGN_JOIN_REQUEST,
  CHECK_CAMPAIGN_JOIN_SUCCESS,
  CHECK_CAMPAIGN_JOIN_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CHECK_CAMPAIGN_JOIN_REQUEST:
      return { ...state, isLoading: true, error: null };
    case CHECK_CAMPAIGN_JOIN_SUCCESS:
      return { ...state, data: { ...state.data, ...action.payload }, isLoading: false, error: null };
    case CHECK_CAMPAIGN_JOIN_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
